import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ImageIcon from '@mui/icons-material/Image';
import { useDispatch } from 'react-redux';
import { detachFiles } from '../../twilio/store/genericActions';

export function FilePreview({ file, disabled }: { file: File; disabled?: boolean }) {
  const dispatch = useDispatch();
  const isImage = file.type.startsWith('image/');
  const url = isImage ? URL.createObjectURL(file) : '';

  const remove = () => dispatch(detachFiles({ filesToDetach: [file] }));

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, border: '1px solid #ddd', borderRadius: 1, p: 1 }}>
      {isImage ? (
        <Box component="img" src={url} alt={file.name} sx={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 0.5 }} />
      ) : (
        <InsertDriveFileIcon color="action" />
      )}
      <Typography variant="body2" sx={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {file.name}
      </Typography>
      <IconButton aria-label="remove" size="small" onClick={remove} disabled={disabled}>
        <CloseIcon fontSize="inherit" />
      </IconButton>
    </Box>
  );
}
export default FilePreview;

